import classes from './Field.module.css';

const Field = ({ value, label, style = {}, sValue = {} }) => {
  return (
    <div className={classes.fieldContainer} style={style}>
      <label className={classes.fieldTitle}>{label}</label>
      <label style={sValue} className={classes.fieldText}>
        {value}
      </label>
    </div>
  );
};

export default Field;
